import { Skeleton } from "src/components/Skeleton/Skeleton";
import { Button } from "src/design-system/components/Button/Button";
import { useScreenMinWidth } from "src/utils/hooks/useScreenMinWidth";
import { FormattedMessage } from "react-intl";
import {
  GettingHereLoading,
  PricingInfoLoading,
  RatingWithBoxLoading,
  TagsLoading,
  TitleLoading,
} from "./LoadingComponents";
import messages from "./messages";

export function ListCardDesktopLoading() {
  const { isXlScreen } = useScreenMinWidth();
  const imgWidth = isXlScreen ? 250 : 200;

  return (
    <div
      className="relative flex min-h-54 cursor-pointer flex-row rounded-lg border-1 border-border bg-fill-solid p-1 focus-visible:ring"
      role="button"
      aria-disabled
      tabIndex={0}
      data-testid="hotel-list-item"
    >
      <Skeleton width={imgWidth} height="" borderRadius="rounded_md" />
      <div className="flex flex-grow-1 flex-col gap-4 p-4">
        <div className="flex flex-grow-1 flex-col items-start gap-2">
          <TitleLoading />
          <RatingWithBoxLoading />
          <TagsLoading />
          <GettingHereLoading />
        </div>
        <div className="flex flex-row flex-wrap justify-end gap-x-4 gap-y-1">
          <PricingInfoLoading />
          <Button isDisabled>
            <FormattedMessage {...messages.callToAction} />
          </Button>
        </div>
      </div>
    </div>
  );
}
